import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CurrencyExchangeModel } from 'src/app/models/archive/currency-exchage.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CurrencyExchangeService {

  constructor(private _httpClient: HttpClient) { }

  createCurrencyExchange(currencyContractModel: CurrencyExchangeModel): Observable<CurrencyExchangeModel> {
    return this._httpClient.post<CurrencyExchangeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currencyExchange.CreateCurrencyExchange}`,
      currencyContractModel);
  }

  deleteCurrencyExchange(currencyId: number): Observable<CurrencyExchangeModel> {
    return this._httpClient.delete<CurrencyExchangeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currencyExchange.DeleteCurrencyExchange}/${currencyId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.currencyExchange.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllCurrencyExchangesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currencyExchange.GetAllCurrencyExchangesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllCurrenciesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currencyExchange.GetAllCurrenciesForSelectAsync}`,);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currencyExchange.GetColumnsForGeneralConsultationAsync}`);
  }

  getCurrencyExchangeById(currencyId: number): Observable<CurrencyExchangeModel> {
    return this._httpClient.get<CurrencyExchangeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currencyExchange.GetCurrencyExchangeById}/${currencyId}`)
  }

  getCurrencyExchangeByCode(currencyId: number, dateExchange: Date): Observable<CurrencyExchangeModel> {
    const itemFilterResponse = new ItemFilterModel("dateExchange", null, null, "");
    itemFilterResponse.wildcard = dateExchange.toUTCString();
    return this._httpClient.post<CurrencyExchangeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currencyExchange.GetCurrencyExchangeByCode}/${currencyId}`,
      itemFilterResponse)
  }

  updateCurrencyExchange(familyContractModel: CurrencyExchangeModel): Observable<CurrencyExchangeModel> {
    return this._httpClient.put<CurrencyExchangeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.currencyExchange.UpdateCurrencyExchange}`,
      familyContractModel);
  }
}
